import { render, staticRenderFns } from "./sideSessions.vue?vue&type=template&id=10ef91d8&scoped=true&"
import script from "./sideSessions.vue?vue&type=script&lang=js&"
export * from "./sideSessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ef91d8",
  null
  
)

export default component.exports